export function getCsrfCookie() {
  const name = "csrftoken";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  const csrfCookie = ca.find((c) => c.trim().startsWith(name));
  return csrfCookie?.split("=")[1];
}
